/* The existing Empire controller owns drawer open/close, scroll lock and search. */
(() => {
  'use strict';
  const instances = new Map();
  function mount(scope = document) {
    scope.querySelectorAll('[data-bc-mobile-catalog]').forEach(drawer => {
      if (instances.has(drawer)) return;
      const header = drawer.closest('[data-site-header]');
      const trigger = header?.querySelector('[data-menu-toggle]');
      const title = drawer.querySelector('[data-bc-catalog-title-label]');
      const back = drawer.querySelector('[data-bc-catalog-back]');
      const panel = drawer.querySelector('[data-mobile-nav-panel]');
      const roots = [...drawer.querySelectorAll('[data-bc-catalog-root]')];
      const levels = [...drawer.querySelectorAll('[data-bc-catalog-level]')];
      const forwards = [...drawer.querySelectorAll('[data-bc-catalog-forward]')];
      if (!trigger || !title || !back || !panel) return;
      const rootTitle = title.textContent;
      const history = [];
      let current = null;
      function show(level, focus = true) {
        current = level;
        roots.forEach(node => { node.hidden = !!level; });
        levels.forEach(node => { node.hidden = level ? node !== level : !node.hasAttribute('data-bc-catalog-root'); });
        forwards.forEach(link => link.setAttribute('aria-expanded', String(link.dataset.bcCatalogForward === level?.id)));
        back.hidden = !level;
        title.textContent = level ? level.dataset.bcCatalogTitle : rootTitle;
        panel.scrollTop = 0;
        if (focus) title.focus({ preventScroll: true });
      }
      const click = event => {
        const link = event.target.closest('[data-bc-catalog-forward]');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const next = levels.find(level => level.id === link.dataset.bcCatalogForward);
          if (!next) return;
          event.preventDefault();
          history.push({ level: current, trigger: link, scrollTop: panel.scrollTop });
          show(next);
        } else if (event.target.closest('[data-bc-catalog-back]')) {
          const previous = history.pop();
          show(previous?.level || null, false);
          panel.scrollTop = previous?.scrollTop || 0;
          (previous?.trigger || title).focus({ preventScroll: true });
        }
      };
      // The native trap initializes on open; recompute visible controls after every drilldown.
      const keydown = event => {
        if (event.key !== 'Tab' || drawer.dataset.open !== 'true') return;
        const controls = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')]
          .filter(node => node.getClientRects().length && !node.closest('[hidden]'));
        if (!controls.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const index = controls.indexOf(document.activeElement);
        const nextIndex = index < 0 ? (event.shiftKey ? controls.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[nextIndex].focus();
      };
      const desktop = window.matchMedia('(min-width: 1024px)');
      function syncState() {
        const opened = drawer.dataset.open === 'true';
        trigger.setAttribute('aria-controls', desktop.matches ? 'site-header-nav' : drawer.id);
        if (desktop.matches) trigger.removeAttribute('aria-haspopup');
        else trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', String(desktop.matches ? header.classList.contains('site-header-nav--open') : opened));
        if (!opened) { history.length = 0; show(null, false); }
      }
      const observer = new MutationObserver(syncState);
      drawer.addEventListener('click', click);
      drawer.addEventListener('keydown', keydown, true);
      observer.observe(drawer, { attributes: true, attributeFilter: ['data-open'] });
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
      desktop.addEventListener('change', syncState);
      show(null, false);
      syncState();
      instances.set(drawer, () => {
        observer.disconnect();
        drawer.removeEventListener('click', click);
        drawer.removeEventListener('keydown', keydown, true);
        desktop.removeEventListener('change', syncState);
      });
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, drawer) => {
      if (event.target.contains(drawer)) { destroy(); instances.delete(drawer); }
    });
  });
})();
